export default {"src":"/_next/static/media/ImportantIconRed.02238a34.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};